export default __webpack_public_path__ + "static/career-faq-bg-710532654a720a55248b8434ed11be7b.png";